import {
  Flex,
  Avatar,
  Button,
  Box,
  IconButton,
  Badge,
  AvatarBadge,
} from '@chakra-ui/react';
import { UserMetaData } from '../../../../core/redux/auth/authTypes';
import { AiOutlineUserSwitch } from 'react-icons/ai';

interface UsersListProps {
  users: UserMetaData[];
  activeUserId: string;
  activeUserMessage: string
  startLoginUser: (userMetaData: UserMetaData) => void;
}
const UsersList: React.FC<UsersListProps> = ({
  users,
  activeUserId,
  activeUserMessage,
  startLoginUser,
}) => {
  return (
    <Box>
      {users.map((user) => {
        return (
          <Flex
            key={user.id}
            alignItems="center"
            p={2}
            borderBottom={2}
            boxShadow="md"
            borderRadius={10}
          >
            <Avatar
              name={user.fullname}
              // src={user.avatar}
              size="md"
              bg="teal.500"
              color="white"
              mr={4}
            >
              {user.id === activeUserId && (
                <AvatarBadge boxSize="1.25em" bg="green.500" />
              )}
            </Avatar>
            <Box>{user.fullname}</Box>

            {user.id !== activeUserId ? (
              <IconButton
                ml="auto"
                icon={<AiOutlineUserSwitch />}
                onClick={() => startLoginUser(user)}
                aria-label="Open Users List"
              />
            ) : (
              <Badge ml="auto" p="1" borderRadius="md" colorScheme="green">
                {activeUserMessage}
              </Badge>
            )}
          </Flex>
        );
      })}
    </Box>
  );
};

export default UsersList;
